export default function DS_Regression_P_Value() {
  return <div>DS_Regression_P_Value Component</div>;
}
